export const feelingsCategories = {
  Happy: [
    { emoji: "😊", name: "Happy" },
    { emoji: "😄", name: "Joyful" },
    { emoji: "😁", name: "Excited" },
    { emoji: "😎", name: "Confident" },
    { emoji: "🥳", name: "Celebratory" },
    { emoji: "🤩", name: "Inspired" },
    { emoji: "😌", name: "Content" },
  ],
  Sad: [
    { emoji: "😢", name: "Sad" },
    { emoji: "😭", name: "Crying" },
    { emoji: "😞", name: "Disappointed" },
    { emoji: "😔", name: "Lonely" },
    { emoji: "💔", name: "Heartbroken" },
    { emoji: "🥺", name: "Upset" },
  ],
  Love: [
    { emoji: "😍", name: "In Love" },
    { emoji: "😘", name: "Affectionate" },
    { emoji: "❤️", name: "Loving" },
    { emoji: "💖", name: "Grateful" },
    { emoji: "🥰", name: "Adored" },
    { emoji: "💘", name: "Crushing" },
  ],
  Angry: [
    { emoji: "😡", name: "Angry" },
    { emoji: "😤", name: "Frustrated" },
    { emoji: "🤬", name: "Furious" },
    { emoji: "🙄", name: "Annoyed" },
    { emoji: "😒", name: "Irritated" },
  ],
  Surprised: [
    { emoji: "😲", name: "Surprised" },
    { emoji: "😱", name: "Shocked" },
    { emoji: "🤯", name: "Mind-blown" },
    { emoji: "😮", name: "Amazed" },
  ],
  Tired: [
    { emoji: "😴", name: "Sleepy" },
    { emoji: "🥱", name: "Yawning" },
    { emoji: "😩", name: "Exhausted" },
    { emoji: "😪", name: "Drowsy" },
  ],
  Sick: [
    { emoji: "🤒", name: "Sick" },
    { emoji: "🤕", name: "Injured" },
    { emoji: "🤢", name: "Nauseous" },
    { emoji: "🤧", name: "Unwell" },
  ],
  Motivated: [
    { emoji: "💪", name: "Strong" },
    { emoji: "🔥", name: "Motivated" },
    { emoji: "⚡", name: "Energetic" },
    { emoji: "🏃", name: "Active" },
    { emoji: "🎯", name: "Focused" },
  ],
  Calm: [
    { emoji: "🧘", name: "Peaceful" },
    { emoji: "🌿", name: "Relaxed" },
    { emoji: "🌊", name: "Calm" },
    { emoji: "☕", name: "Chill" },
  ],
};
